import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
// import { Link } from 'react-router-dom';

// components
import Grid from '@material-ui/core/Grid';
// import Breadcrumbs from '@material-ui/core/Breadcrumbs';
// import Container from '@material-ui/core/Container';
// import Modal from '@material-ui/core/Modal';
// import AddEditEvent from './components/AddEditEvent';
import Typography from 'components/shared/Typography';
import clsx from 'clsx';
// import LoadingButton from 'components/shared/LoadingButton';
// import Calendar from './components/Calendar';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { SPACING_THIRD, SPACING, SPACING_HALF, SPACING_LEAST, SPACING_DOUBLE } from 'constants/spacing';
import RectangularGrid from 'components/shared/RectangularGrid';
import { Link } from '@material-ui/core';

// hooks
// import { useAllEvents, useCreateEvent, useUpdateEvent } from 'hooks/event';
// import { useDivisionValue } from 'providers/DivisionProvider';

// utils
// import { arrayUniqueKey } from 'utils';

//assets
import successfulPaymentImage from 'assets/images/customer/payment_successful.png';

import LoadingButton from 'components/shared/LoadingButton';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPanel: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  form: {
    width: '100%',
  },
  buttonWraper: {
    marginTop: theme.spacing(SPACING),
    bottom: '0',
    position: 'relative',
  },
  backButton: {
    backgroundColor: 'transparent',
    color: '#878787',
    border: '1px solid',
    borderColor: '#878787',
    '&:hover':{
      backgroundColor: 'transparent',
      color:"#333",
      borderColor: '#333',
    }
  },
  monkey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneInput: {
    '& .MuiInputBase-input::placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
  },
  largeLabel: {
    marginTop: 15,
    fontSize: theme.typography.pxToRem(25),
    height: '75%',
    '&:disabled':{
      color: '#959595'
    }
  },
  wholepage: {
    width: '100vw',
    height: '100vh',
    backgroundColor: '#e5e5e5',
  },
  mainContainer: {
    backgroundColor: '#f5f5f5',
    // borderRadius:"10px",
    position: 'relative',
    top: '15%',
    padding: '0px',

    [theme.breakpoints.down('xs')]: {
      backgroundColor: '#e5e5e5',
      top: '0',
    },
  },
  branchCard: {
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: '#D2D2D2',
    borderRadius: '20px',
    marginBottom: '10px',
    [theme.breakpoints.down('xs')]: {
      // marginBottom:"10px",
      // margin: '3%',
    },
  },
  branchCardSelected: {
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: '#24AF6E',
    backgroundColor: '#f1f7f5',
    borderRadius: '20px',
    marginBottom: '10px',

    [theme.breakpoints.down('xs')]: {
      // marginBottom:"10px",
      margin: '3%',
    },
  },
  checkbox: {
    position: 'relative',
    top: '35%',
    width: '50%',
  },
  singleLineText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

function SuccessfulPayment({ selectedBranch, setSelectedBranch, branches_data, nextStep, event,payment }) {
  const classes = useStyles();
  const history = useHistory();
  //   const [selectedBranch, setSelectedBranch] = useState('');
  const onReset = (e) => {
    history.push("/")
  };
  const dateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  };
  return (
    <Grid container spacing={0} style={{ height: '100%', overflowX: 'hide' }}>
      <Grid item xs={12} md={6} style={{ height: '100%', padding: '3%', overflowY: 'auto' }}>
        <Grid container spacing={SPACING_HALF} style={{ alignContent: 'space-between', height: '100%' }}>
          <Grid item xs={12}>
            <Grid container spacing={SPACING_HALF}>
              <Grid
                item
                xs={12}
                style={{ alignContent: 'center', textAlign: 'center', marginTop: '3%' }}
              >
                <Typography variant="h1">پرداخت موفقیت آمیز</Typography>
              </Grid>
              <Grid item xs={12} style={{ alignContent: 'center', textAlign: 'center' }}>
                <Typography variant="h4" style={{ color: '#838383' }}>
                  نوبت شما ثبت شد.
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={SPACING_THIRD}
              style={{
                marginTop: '10%',
                justifyContent: 'space-evenly',
                textAlign: 'center',
                padding: '5px',
              }}
            >
              <Typography variant="h5" style={{ color: '#838383', textAlign:"right" }}>
                  لطفا اطلاعات زیر را ذخیره کرده و در زمان مراجعه به مسئول مربوطه ارائه دهید.
                </Typography>
              

              {/* </div> */}
            </Grid>
            <Grid
                item
                xs={12}
                style={{ alignContent: 'center', textAlign: 'center', marginTop: '3%' }}
              >
                <Grid container spacing={SPACING_HALF} className={classes.rightLabelContainer}>
                  <Grid item xs={6}>
                    <Typography variant="h5">عنوان سرویس</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">{event?.service?.title || '-'}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">تاریخ انتخابی</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">
                      {new Date(event?.start)?.toLocaleDateString('fa-IR', dateOptions) ||
                        '-'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">زمان شروع</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">
                      {new Date(event?.start)?.toLocaleTimeString('fa-IR', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      }) || '-'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">زمان تقریبی اتمام</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">
                      {new Date(event?.end)?.toLocaleTimeString('fa-IR', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      }) || '-'}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={SPACING_HALF} style={{marginTop:"7%"}}>
                  <Grid item xs={6} className={classes.rightLabel}>
                    <Typography variant="h5">مبلغ پرداختی</Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.leftLabel}>
                    <Typography variant="h5">
                      {`${event?.deposit?.toLocaleString() || '-'} ریال`}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.rightLabel}>
                    <Typography variant="h5">شماره پیگیری</Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.leftLabel}>
                    <Typography variant="h5">
                      {payment?.refID}
                    </Typography>
                  </Grid>

                </Grid>
              </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid item xs={12} className={classes.buttonWraper}>
              <LoadingButton
                className={clsx(classes.largeLabel, classes.backButton)}
                type="submit"
                // size="small"
                fullWidth
                variant="contained"
                color="primary"
                disabled={selectedBranch === ''}
                onClick={onReset}
              >
                بازگشت به ابتدا
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6} className={classes.leftPanel}>
        <img src={successfulPaymentImage} alt="left" height={'70%'} />
      </Grid>
    </Grid>
  );
}

export default SuccessfulPayment;
